import { multiFranchiseAxios } from "../axios/multiFranchiseAxios";
import {
  IRequestCount,
  IPendingWork,
  IPendingWorkFilters,
  IRequestCatalogProduct,
  IRequestDecision,
  IRequestDetail,
  IRequestFilters,
  IRequestPolicy,
  IRequestSummary,
} from "../../compiler/requestCenter.interface";
const root = "/procurement/admin/request-center";
const context = (franchise: string) => ({ headers: { "X-Franchise-Context": franchise } });
export const APIRequestPendingWork = async (
  franchise: string,
  params: IPendingWorkFilters
): Promise<IPendingWork> =>
  (await multiFranchiseAxios.get(`${root}/pending-work`, { ...context(franchise), params })).data;
export const APIRequestCases = async (
  franchise: string,
  params: IRequestFilters
): Promise<{ items: IRequestSummary[]; total: number; page: number; limit: number }> =>
  (await multiFranchiseAxios.get(`${root}/cases`, { ...context(franchise), params })).data;
export const APIRequestSummary = async (
  franchise: string,
  params: IRequestFilters
): Promise<IRequestCount[]> =>
  (await multiFranchiseAxios.get(`${root}/summary`, { ...context(franchise), params })).data;
export const APIRequestDetail = async (franchise: string, uuid: string): Promise<IRequestDetail> =>
  (await multiFranchiseAxios.get(`${root}/cases/${uuid}`, context(franchise))).data;
export const APIRequestCatalogue = async (
  franchise: string,
  uuid: string
): Promise<IRequestCatalogProduct[]> =>
  (await multiFranchiseAxios.get(`${root}/cases/${uuid}/products`, context(franchise))).data;
export const APIRequestDecision = async (
  franchise: string,
  payload: IRequestDecision
): Promise<IRequestDetail> =>
  (
    await multiFranchiseAxios.post(
      `${root}/cases/${payload.uuid}/${payload.items ? "approve" : "reject"}`,
      {
        version: payload.version,
        reason: payload.reason,
        ...(payload.items ? { items: payload.items } : {}),
      },
      context(franchise)
    )
  ).data;
export const APIRequestSettings = async (franchise: string): Promise<IRequestPolicy> =>
  (await multiFranchiseAxios.get(`${root}/settings`, context(franchise))).data;
export const APIUpdateRequestSettings = async (
  franchise: string,
  payload: IRequestPolicy
): Promise<IRequestPolicy> =>
  (
    await multiFranchiseAxios.patch(
      `${root}/settings`,
      {
        version: payload.version,
        normal_days_before: payload.normal_days_before,
        normal_close_time: payload.normal_close_time,
        special_days_before: payload.special_days_before,
        special_close_time: payload.special_close_time,
      },
      context(franchise)
    )
  ).data;
export const requestError = (error: unknown) => {
  const e = error as { response?: { data?: { message?: string | string[] } }; message?: string };
  const m = e?.response?.data?.message;
  return Array.isArray(m) ? m.join(" / ") : m || e?.message || "โหลดข้อมูลไม่สำเร็จ กรุณาลองใหม่";
};
export const APIRequestProductSummary = async (
  franchise: string,
  params: IRequestFilters
): Promise<import("../../compiler/requestCenter.interface").IRequestProductSummary[]> =>
  (await multiFranchiseAxios.get(`${root}/product-summary`, { ...context(franchise), params }))
    .data;
